var _path, _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKundenlogoHansefit(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 90,
    viewBox: "0 0 180 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 8C0.5 3.85786 3.85786 0.5 8 0.5H172C176.142 0.5 179.5 3.85786 179.5 8V82C179.5 86.1421 176.142 89.5 172 89.5H8C3.85786 89.5 0.5 86.1421 0.5 82V8Z",
    stroke: "#F3F0E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_972_615",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 179,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 179,
    height: 88,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_972_615)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_972_615)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_972_615)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.274 37.4014L70.6861 51.9468H67.5174L68.5736 46.0656H63.6093L62.553 51.9468H59.3843L62.0249 37.4014H65.1936L64.1374 43.2301H69.1018L70.158 37.4014H73.274Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9387 49.5838H77.7631L76.654 51.9468H73.2212L80.4037 37.4014H84.5759L86.6356 51.9468H83.2027L82.9387 49.5838ZM82.6218 46.8533L82.2521 43.1775C82.1465 42.1798 82.0409 40.6045 82.0937 39.9219H82.0409C81.8824 40.657 81.1959 42.1798 80.7734 43.1775L79.0306 46.8533H82.6218Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.571 46.9583H98.6238C98.6767 45.8556 98.9935 43.7026 99.152 42.7049L100.103 37.4014H103.166L100.578 51.9468H97.6204L94.8742 45.9606C94.346 44.8579 93.8179 43.3876 93.7123 42.5474H93.6595C93.6067 43.6501 93.2898 45.8031 93.1313 46.8008L92.2335 51.9468H89.1704L91.7582 37.4014H94.7157L97.5148 43.6501C97.9373 44.6478 98.4654 46.1706 98.571 46.9583Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.176 42.1272C106.176 38.819 108.817 37.1387 112.408 37.1387C116.158 37.1387 117.636 38.9765 117.108 41.6021H113.781C113.992 40.5519 113.57 39.7117 111.933 39.7117C110.243 39.7117 109.503 40.6044 109.503 41.6021C109.503 42.3372 110.031 42.7048 111.088 43.0724L113.623 44.0176C115.154 44.5952 116.158 45.5929 116.158 47.2207C116.158 50.5289 113.306 52.2617 109.662 52.2617C105.595 52.2617 104.275 50.2663 104.803 47.6408H108.13C107.919 48.796 108.394 49.6887 110.137 49.6887C111.88 49.6887 112.725 48.8486 112.725 47.7983C112.725 47.0107 112.091 46.6956 111.352 46.4331L108.553 45.3303C107.127 44.7527 106.176 43.7025 106.176 42.1272Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.132 40.1847L123.551 43.3878H129.413L128.938 45.9608H123.076L122.495 49.2165H129.044L128.568 51.9996H118.904L121.492 37.4541H131.156L130.681 40.2372H124.132V40.1847Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.758 40.1844L137.124 43.6501H142.881L142.405 46.4332H136.649L135.698 51.9468H132.529L135.117 37.4014H144.676L144.201 40.1844H137.758Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.479 51.9468H145.31L147.898 37.4014H151.067L148.479 51.9468Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.64 40.1844H160.784L158.725 51.9468H155.556L157.616 40.1844H153.76L154.236 37.4014H165.115L164.64 40.1844Z",
    fill: "#F3F0E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4443 29V60.2438H46.8677V29H15.4443ZM28.0665 52.0522H24.845L25.9012 46.066H20.884L21.4121 43.1779H26.4821L27.5384 37.2442H30.7599L28.0665 52.0522ZM40.7415 46.0135H35.7243L34.6681 51.9997H31.4465L34.0871 37.1917H37.3087L36.2524 43.1254H41.3224L40.7415 46.0135Z",
    fill: "#F3F0E5"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_972_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 80,
    fill: "white",
    transform: "translate(11 5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_972_615"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155.556,
    height: 32,
    fill: "white",
    transform: "translate(15.4443 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKundenlogoHansefit);
export default __webpack_public_path__ + "static/media/kundenlogo-hansefit.dae18c15259d0474c8cf40acf870235d.svg";
export { ForwardRef as ReactComponent };